// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-T4d","col":"styles_col__pK-Kv","actions":"styles_actions__2H8gk","conflict":"styles_conflict__2n4Rd"};